import React, { Fragment, useState, useEffect } from 'react';
import Breadcrumb from '../common/breadcrumb';

const ComunicadoExterno = (props) => {
    const [comunicado, setComunicado] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [slug_or_id] = useState(props.match.params.slug_or_id);

    useEffect(() => {
        fetch(`/z_comunicado_externo/${slug_or_id}`)
            .then((res) => res.json())
            .then((res) => {
                if (res.status === 1 && res.result) {
                    setComunicado(res.result);
                    setLoading(false);
                } else {
                    setError('Comunicado no encontrado');
                    setLoading(false);
                }
            })
            .catch((err) => {
                console.log('ERROR: ' + err);
                setError('Error al cargar el comunicado');
                setLoading(false);
            });
    }, [slug_or_id]);

    if (loading) {
        return (
            <Fragment>
                <Breadcrumb title="Detalles de comunicado" parent="Comunicados" />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 text-center py-5">
                            <div className="loader-box">
                                <div className="loader">
                                    <div className="line bg-warning"></div>
                                    <div className="line bg-warning"></div>
                                    <div className="line bg-warning"></div>
                                    <div className="line bg-warning"></div>
                                </div>
                            </div>
                            <h5 className="mt-3">Cargando comunicado...</h5>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }

    if (error || !comunicado) {
        return (
            <Fragment>
                <Breadcrumb title="Detalles de comunicado" parent="Comunicados" />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body text-center py-5">
                                    <h4 className="text-danger">{error || 'Comunicado no encontrado'}</h4>
                                    <button 
                                        className="btn btn-primary mt-3"
                                        onClick={() => props.history.goBack()}
                                    >
                                        Volver
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }

    return (
        <Fragment>
            <Breadcrumb title="Detalles de comunicado" parent="Comunicados" />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        {/* Imagen principal - Ancho completo */}
                        <div style={{ marginBottom: '30px' }}>
                            <img 
                                src={`https://comunicados.joseluisteran.com/comunicados/${comunicado.ID_COMUNICADO}/portada.jpg`}
                                alt={comunicado.TITULO_COMUNICADO}
                                onError={(e) => { e.target.src = "https://terancomunicados.com/assets/images/banner.png" }}
                                style={{ 
                                    width: '100%', 
                                    maxHeight: '400px',
                                    objectFit: 'cover',
                                    borderRadius: '10px'
                                }}
                            />
                        </div>

                        {/* Fecha y Título */}
                        <div style={{ marginBottom: '30px' }}>
                            <p style={{ 
                                fontSize: '14px', 
                                color: '#666',
                                marginBottom: '10px',
                                fontWeight: '500'
                            }}>
                                {comunicado.FECHA_FORMATO || new Date(comunicado.FECHA_COMUNICADO).toLocaleDateString('es-MX', { 
                                    year: 'numeric', 
                                    month: 'long', 
                                    day: 'numeric' 
                                })}
                            </p>
                            <h2 style={{ 
                                fontSize: '28px',
                                fontWeight: '700',
                                color: '#2c3e50',
                                lineHeight: '1.3',
                                marginBottom: '20px'
                            }}>
                                {comunicado.TITULO_COMUNICADO}
                            </h2>
                            {comunicado.AUTOR_COMUNICADO && (
                                <p style={{ 
                                    fontSize: '14px', 
                                    color: '#666',
                                    fontStyle: 'italic'
                                }}>
                                    Fuente de información: {comunicado.AUTOR_COMUNICADO}
                                </p>
                            )}
                        </div>

                        {/* Contenido/Introducción */}
                        {comunicado.INTRODUCCION_COMUNICADO && (
                            <div style={{ 
                                fontSize: '16px', 
                                lineHeight: '1.8',
                                color: '#333',
                                marginBottom: '30px'
                            }}>
                                <p>{comunicado.INTRODUCCION_COMUNICADO}</p>
                            </div>
                        )}

                        {/* Visor de PDF embebido */}
                        {comunicado.ARCHIVOS && comunicado.ARCHIVOS.length > 0 && (
                            <div style={{ marginBottom: '30px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                {comunicado.ARCHIVOS.map((archivo, index) => {
                                    const archivoNombre = archivo.nombre || archivo;
                                    const extension = (archivo.extension || '').toLowerCase();
                                    
                                    // Solo mostrar PDFs embebidos
                                    if (extension === '.pdf' || archivoNombre.toLowerCase().endsWith('.pdf')) {
                                        return (
                                            <div 
                                                key={index} 
                                                style={{ 
                                                    marginBottom: '20px',
                                                    backgroundColor: '#fff',
                                                    padding: '20px',
                                                    borderRadius: '10px',
                                                    boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
                                                    width: '80%'
                                                }}
                                            >
                                                <iframe
                                                    src={`${archivoNombre}`}
                                                    style={{
                                                        width: '100%',
                                                        height: '820px',
                                                        border: 'none',
                                                        borderRadius: '5px'
                                                    }}
                                                    title={`PDF ${index + 1}`}
                                                />
                                            </div>
                                        );
                                    }
                                    return null;
                                })}
                                
                                {/* Links de descarga para todos los archivos */}
                                <div style={{ 
                                    padding: '20px',
                                    backgroundColor: '#f8f9fa',
                                    borderRadius: '5px',
                                    marginTop: '20px'
                                }}>
                                    <h6 style={{ 
                                        marginBottom: '15px',
                                        fontSize: '16px',
                                        fontWeight: '600'
                                    }}>
                                        <i className="icofont icofont-clip"></i> Archivos adjuntos
                                    </h6>
                                    <ul style={{ 
                                        listStyle: 'none',
                                        padding: 0,
                                        margin: 0
                                    }}>
                                        {comunicado.ARCHIVOS.map((archivo, key) => (
                                            <li key={key} style={{ marginBottom: '10px' }}>
                                                <a 
                                                    href={`${archivo.nombre || archivo}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{
                                                        color: '#007bff',
                                                        textDecoration: 'none',
                                                        fontSize: '14px',
                                                        display: 'inline-flex',
                                                        alignItems: 'center'
                                                    }}
                                                >
                                                    <i className="fa fa-download" style={{ marginRight: '8px' }}></i>
                                                    {archivo.nombre || archivo}
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        )}

                        {/* Galería de imágenes */}
                        {comunicado.GALERIA && comunicado.GALERIA.length > 0 && (
                            <div style={{ marginBottom: '30px' }}>
                                <h5 style={{ 
                                    marginBottom: '20px',
                                    fontSize: '20px',
                                    fontWeight: '600'
                                }}>
                                    Galería
                                </h5>
                                <div className="row">
                                    {comunicado.GALERIA.map((imagen, index) => (
                                        <div key={index} className="col-md-4 col-sm-6 mb-3">
                                            <img 
                                                src={`${comunicado.MEDIA_URL}/assets/images/comunicados/${comunicado.ID_COMUNICADO}/${imagen.nombre || imagen}`}
                                                alt={`Galería ${index + 1}`}
                                                className="img-fluid"
                                                style={{ 
                                                    borderRadius: '8px', 
                                                    cursor: 'pointer', 
                                                    width: '100%',
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                                    transition: 'transform 0.2s'
                                                }}
                                                onClick={(e) => window.open(e.target.src, '_blank')}
                                                onError={(e) => { e.target.style.display = 'none' }}
                                                onMouseOver={(e) => e.target.style.transform = 'scale(1.02)'}
                                                onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Botón volver */}
                        <div className="text-center" style={{ marginTop: '40px', marginBottom: '40px' }}>
                            <button 
                                className="btn btn-secondary"
                                onClick={() => props.history.goBack()}
                                style={{
                                    padding: '10px 30px',
                                    fontSize: '16px',
                                    borderRadius: '5px'
                                }}
                            >
                                <i className="fa fa-arrow-left mr-2"></i>
                                Volver
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default ComunicadoExterno;
